import styled, { css, th } from '@xstyled/styled-components'
import type { PropsOf } from '../../system'
import type { BlockOptions, BlockProps } from '../block/block'
import { Block } from '../block/block'
import type { TextProps } from '../typography/text'
import { Text } from '../typography/text'

export interface FormProps extends PropsOf<'form'>, BlockOptions {}

export interface FormGroupProps extends BlockProps {}

export interface FormLabelProps
  extends Omit<PropsOf<'label'>, keyof TextProps>,
    TextProps {
  required?: boolean
  showOptionalIndicator?: boolean
}

export interface FormFeedbackMessageProps extends TextProps {
  isError?: boolean
}

export interface FormHelpMessageProps extends TextProps {}

export const Form = (props: FormProps): JSX.Element => (
  <Block as='form' spreadX {...props} />
)

export const FormGroup = (props: FormGroupProps): JSX.Element => (
  <Block gap={8} {...props} />
)

export const FormLabel = (props: FormLabelProps): JSX.Element => (
  <FormLabelRoot
    as='label'
    fontWeight='medium'
    text='md'
    color='grey.d3'
    {...props}
  />
)

export const FormFeedbackMessage = (
  props: FormFeedbackMessageProps
): JSX.Element => (
  <FormFeedbackMessageRoot as='span' fontWeight={400} text='md' {...props} />
)

export const FormHelpMessage = (props: FormHelpMessageProps): JSX.Element => (
  <Text as='span' text='sm' fontWeight={400} color='grey.d2' {...props} />
)

const FormLabelRoot = styled(Text)`
  ${({ required, showOptionalIndicator }) =>
    !required &&
    showOptionalIndicator &&
    css`
      &::after {
        content: '(Optional)';
        font-size: 0.875em;
        color: ${th.color('grey.d2')};
        margin-left: 4px;
      }
    `}

  ${({ required = true }) =>
    required &&
    css`
      &::after {
        content: '*';
        color: ${th.color('error')};
        margin-left: 4px;
      }
    `}
`

const FormFeedbackMessageRoot = styled(Text)`
  ${({ isError = false }) =>
    isError &&
    css`
      color: ${th.color('error')};
    `}
`
